module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"fi":{"Tunnistaudu pankkitunnuksillasi":"Tunnistaudu pankkitunnuksillasi","Testihenkilötunnus":"Testihenkilötunnus"},"sv":{"Tunnistaudu pankkitunnuksillasi":"Identifiera dig med nätbankskoder","Testihenkilötunnus":"Testpersonbeteckning"}}')
  delete Component.options._Ctor
}
